import React from "react";
import { useResource } from "../../../../services";
import { ParticipantFile, type ProfessionalTraining } from "../../../../types/components";
import { useUserContext } from "../../../../utils/contexts/UserProvider";
import { StartingExamSection } from "./exam/StartingExamSection";
import { DocumentsSection } from "./documents/DocumentsSection";
import { ProfessionalTrainingSection } from "./professional-training/ProfessionalTrainingSection";
import { useStartingExam } from "../../../../utils/hooks/data/useStartingExam";
import { createResourceUrl } from "../../../../utils/data";
import { DateTime } from "luxon";

export const MainSection = () => {
  const { user } = useUserContext();

  const { data: startingExam } = useStartingExam();
  const { data: documents } = useResource<ParticipantFile[]>(
    createResourceUrl("/common/participant-file", {
      include: ["type", "status"],
      filters: {
        "eq:participant_id": user?.id,
        "notEq:type.code": "certificate",
      },
    }),
    user,
  );

  const { data: professionalTrainings } = useResource<ProfessionalTraining[]>(
    createResourceUrl("/common/professional-training", {
      include: ["status"],
      filters: {
        "eq:year": DateTime.now().year,
        "eq:user_id": user?.id,
      },
    }),
    user,
  );

  return (
    <div className="flex flex-col bg-gray-100 px-[48px] rounded pt-[40px] pb-[80px] gap-[40px] min-h-full">
      <div className="flex flex-col gap-[40px]">
        <StartingExamSection startingExam={startingExam} />
        <DocumentsSection documents={documents} />
        <ProfessionalTrainingSection data={professionalTrainings?.[0]} />
      </div>
    </div>
  );
};
